import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import AuthenticationReducer from "services/authentication/reducer";
import DisplaysReducer from "services/displays/reducer";
import ParkStatisticsReducer from "services/parkStatistics/reducer";
import PedestrianStatisticsReducer from "services/pedestrianStatistics/reducer";
import GlobalFiltersReducer from "services/globalFilters/reducer";
import CustomAnalysisReducer from "services/customAnalysis/reducer";
import UserReducer from "services/user/reducer";
import ContractReducer from "services/contract/reducer";
import LiveReducer from "services/live/reducer";
import MapReducer from "services/map/reducer";
import FlowReducer from "services/flow/reducer";
import AvailableParkingReducer from "services/availableParking/reducer";
import ParkedCarsReducer from "services/parkedCars/reducer";
import ReportsReducer from "services/reports/reducer";
import NonMovingCarsReducer from "services/nonMovingCars/reducer";
import IndicatorsReducer from "services/indicators/reducer";
import HeatmapOccupancyReducer from "services/heatmapOccupancy/reducer";
import VisitorCharacteristicsReducer from "services/visitorCharacteristics/reducer";
import ConfigSectorsReducer from "services/configSectors/reducer";
import IntlReducer from "services/intl/reducer";
import AlertFactoryReducer from "services/alertFactory/reducer";
import AutomaticSystemsReducer from "services/gates/AutomaticSystems/reducer";

const getAppReducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    Authentication: AuthenticationReducer,
    AvailableParking: AvailableParkingReducer,
    CustomAnalysis: CustomAnalysisReducer,
    Contract: ContractReducer,
    Displays: DisplaysReducer,
    Flow: FlowReducer,
    GlobalFilters: GlobalFiltersReducer,
    HeatmapOccupancy: HeatmapOccupancyReducer,
    Indicators: IndicatorsReducer,
    Live: LiveReducer,
    Map: MapReducer,
    NonMovingCars: NonMovingCarsReducer,
    ParkedCars: ParkedCarsReducer,
    ParkStatistics: ParkStatisticsReducer,
    PedestrianStatistics: PedestrianStatisticsReducer,
    Reports: ReportsReducer,
    User: UserReducer,
    VisitorCharacteristics: VisitorCharacteristicsReducer,
    ConfigSectors: ConfigSectorsReducer,
    Intl: IntlReducer,
    AlertFactory: AlertFactoryReducer,
    AutomaticSystems: AutomaticSystemsReducer,
  });

export default getAppReducers;
